import React, { useMemo } from 'react';
import FundingReportChartCard, { FundingReportBarChart } from './FundingReportChartCard';

const FundingReadinessReport = ({ data, loading }) => {
  const tierItems = useMemo(() => Object.entries(data?.readinessTierDistribution || {}).map(([label, value]) => ({
    label,
    value,
  })), [data]);

  if (loading) return <p className="text-sm text-[var(--fg-muted)]">Loading readiness report...</p>;
  if (!data) return <p className="text-sm text-[var(--fg-muted)]">No readiness data available.</p>;

  return (
    <div className="space-y-4">
      <div className="grid gap-3 sm:grid-cols-3">
        <div className="rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-4 py-3">
          <div className="text-xs text-[var(--fg-muted)]">Average score</div>
          <div className="text-lg font-bold text-[var(--fg-accent)]">{data.averageReadinessScore ?? 0}% estimated</div>
        </div>
        <div className="rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-4 py-3">
          <div className="text-xs text-[var(--fg-muted)]">Ready for match</div>
          <div className="text-lg font-bold text-[var(--fg-text)]">{data.clientsReadyForMatch ?? 0}</div>
        </div>
        <div className="rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-4 py-3">
          <div className="text-xs text-[var(--fg-muted)]">Needing attention</div>
          <div className="text-lg font-bold text-[var(--fg-text)]">{data.clientsNeedingAttention ?? 0}</div>
        </div>
      </div>
      <FundingReportChartCard title="Readiness tier distribution" subtitle="Estimated tiers across clients">
        <FundingReportBarChart items={tierItems} />
      </FundingReportChartCard>
      <div className="grid gap-4 xl:grid-cols-2">
        <FundingReportChartCard title="Missing document drivers" subtitle="Top missing categories">
          <FundingReportBarChart
            items={(data.missingDocumentDrivers || []).map((row) => ({ label: row.category, value: row.count }))}
          />
        </FundingReportChartCard>
        <FundingReportChartCard title="Top blockers" subtitle="Most common readiness blockers">
          <FundingReportBarChart
            items={(data.topBlockers || []).map((row) => ({ label: row.blocker, value: row.count }))}
          />
        </FundingReportChartCard>
      </div>
    </div>
  );
};

export default FundingReadinessReport;
